import axios from '@/plugins/axios'
import * as actionTypes from '@/store/action-types'
import { GlobalState } from '@/types'
import { MessagingState } from '@/types/application-state'
import { SystemMessage } from '@/model/messaging/Message'
import * as mutationTypes from '@/store/mutation-types'
import * as getterTypes from '@/store/getter-types'
import { MESSAGING_GET_SHOW_MENU } from '@/store/getter-types'
import { UserMessage } from '@/model/messaging/UserMessage'

const state: MessagingState = {
  showMenu: false,
  messagesLength: 0,
  messages: [],
  notes: [],
  tasks: [],
  readMessages: [],
  userMessages: []
}

const getters = {
  [MESSAGING_GET_SHOW_MENU] (state: MessagingState): boolean {
    return state.showMenu
  },
  [getterTypes.MESSAGING_GET_MESSAGES_LIST] (state: MessagingState): SystemMessage[] {
    return state.messages
  },
  [getterTypes.MESSAGING_GET_READ_MESSAGES_LIST] (state: MessagingState): SystemMessage[] {
    return state.readMessages
  },
  [getterTypes.GET_USER_MESSAGES] (state: MessagingState): UserMessage[] {
    return state.userMessages
  },
}

const mutations = {
  [mutationTypes.MESSAGING_SET_MENU_STATE] (state: MessagingState, value: boolean): void {
    state.showMenu = value
  },

  [mutationTypes.MESSAGING_SET_MESSAGES_DATA_MUTATION] (state: MessagingState, payload: Array<SystemMessage>): void {
    state.messages = payload
  },
  [mutationTypes.MESSAGING_SET_NOTES_DATA_MUTATION] (state: MessagingState, payload: Array<SystemMessage>): void {
    state.messages = payload
  },
  [mutationTypes.MESSAGING_SET_TASKS_DATA_MUTATION] (state: MessagingState, payload: Array<SystemMessage>): void {
    state.messages = payload
  },
  [mutationTypes.MESSAGING_SET_READ_MESSAGES_MUTATION] (state: MessagingState, payload: Array<SystemMessage>): void {
    state.readMessages = payload
  },
  [mutationTypes.ADD_USER_MESSAGES_MUTATION] (state: MessagingState, payload: UserMessage[]): void {
    state.userMessages = payload
  },

  [mutationTypes.REMOVE_USER_MESSAGES_MUTATION] (state: MessagingState): void {
    state.userMessages = []
  },
}

const actions = {
  [actionTypes.ADD_USER_MESSAGES] ({ commit }: { commit: Function }, payload: UserMessage[]): void {
    commit(mutationTypes.ADD_USER_MESSAGES_MUTATION, payload)
  },

  [actionTypes.REMOVE_USER_MESSAGES] ({ commit }: { commit: Function }): void {
    commit(mutationTypes.REMOVE_USER_MESSAGES_MUTATION)
  },

  async [actionTypes.MESSAGING_LOAD_NEW_MESSAGES] (
    { rootState }: { rootState: GlobalState }): Promise<any> {
    const response = await axios.post('/api/Messaging', null, {
      params: {
        'All': ''
      }
    })

    const data = response.data
    if(data.length > state.messagesLength) {
      state.showMenu = true
    }
    state.messagesLength = data.length

    return SystemMessage.createListFromResponse(data, state.messages)
  },

  async [actionTypes.MESSAGING_DELETE_MESSAGES] (
    { rootState }: { rootState: GlobalState }): Promise<any> {
    const response = await axios.post('/api/Messaging', null, {
      params: {
        'action': '',
        'type': ''
      }
    })

    return response.data
  },

  async [actionTypes.DELETE_USER_MESSAGES] (
    { rootState }: { rootState: GlobalState }, payload: number[]): Promise<any> {
    const response = await axios.post('/api/Messaging/DeleteUserMessages', payload)

    return response.data
  }
}

const messagingModule = {
  state,
  getters,
  mutations,
  actions
}

export default messagingModule

